/*QR code signin */

import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ApiClient from "../methods/api/apiClient";
import { decryptId } from "../components/common/Encryption/encryption";
import { toast } from "react-toastify";
import datepipeModel from "../models/datepipemodel";
import { encryptId } from "../components/common/Encryption/encryption";

const CheckIn = () => {
  const { eventid } = useParams();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user);
  const [loading, setLoading] = useState(true);
  const [eventData, setEventData] = useState<any>(null);
  const [error, setError] = useState<string>("");
  const [id, setId] = useState<string>("");
  const [originalEncryptedId, setOriginalEncryptedId] = useState<string>("");

useEffect(() => {
  console.log("CheckIn component loaded");
  console.log("User state:", user);
  console.log("User logged in:", !!user?._id);
  console.log("Event ID:", eventid);

  if (!eventid) {
    setError("No event ID provided");
    setLoading(false);
    return;
  }
  
  setId(eventid); // Now TypeScript knows eventid is not undefined
  
  if (!user?._id) {
    console.log("Redirecting to login");
    navigate(`/login?eventId=${eventid}&checkin=true`);
    return;
  }
  
  console.log("User is logged in, checking in");
  checkInUserWithId(eventid);
}, [user, eventid]);

const checkInUserWithId = async (eventId: string) => {
  if (!eventId) return;
  
  try {
    console.log("Fetching event details for:", eventId);
    const eventRes = await ApiClient.get('api/event/details', { id: eventId });
    
    if (eventRes.success) {
      setEventData(eventRes.data);
      // Store the correct encrypted ID from the event data
      setOriginalEncryptedId(eventRes.data.encryptedId || await encryptId(eventId));
    }

      // Check in the user
      const checkinRes = await ApiClient.post('api/checkin', {
        eventId: eventId,
        email: user.email,
        userId: user._id
      });

      if (checkinRes.success) {
        toast.success("Successfully checked in!");
      } else {
        toast.error(checkinRes.message || "Check-in failed");
      }
    } catch (error) {
      toast.error("Check-in failed");
    } finally {
      setLoading(false);
    }
  };

  // Handle error state
  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md text-center max-w-md">
          <div className="text-red-500 text-6xl mb-4">✗</div>
          <h1 className="text-2xl font-bold mb-2">Invalid Link</h1>
          <p className="text-gray-600 mb-4">This check-in link is not valid.</p>
          <button 
            onClick={() => navigate('/dashboard')}
            className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Checking you in...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md text-center max-w-md">
        <div className="text-green-500 text-6xl mb-4">✓</div>
        <h1 className="text-2xl font-bold mb-2">Check-In Successful!</h1>
        <p className="text-gray-600 mb-4">
          You have successfully checked in for <strong>{eventData?.title}</strong> starting at <strong>{datepipeModel.formatDateToTimezone(eventData?.date, eventData?.timezone)}</strong>
        </p>
        <button 
          onClick={async () => navigate(`/event/detail/${await encryptId(eventid)}`)}
          className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
        >
          View Event Details
        </button>
      </div>
    </div>
  );
};

export default CheckIn;